import moment from 'moment';
import { IWorkingHoursLogFilters } from 'src/view/screens/WorkingHoursLogScreen/screens/WorkingHoursLog/types/WHLog';

export enum WH_LOG_COLUMN {
  PROFILE = 'profile',
  DATE = 'date',
  ACTION = 'action',
  AUTHOR = 'author',
  DETAILS = 'details',
}

export const defaultWorkingHoursLogFilters: IWorkingHoursLogFilters = {
  profileIds: undefined,
  sortBy: undefined,
  sortDir: undefined,
  startDate: moment().startOf('month').unix(),
  endDate: moment().unix(),
};
